const components = {
    install: function (Vue) {
        Vue.component('file_Upload', () => import('../components/file_Upload/file_Upload'))
        Vue.component('paging', () => import('../components/paging/paging'))
        Vue.component('Area', () => import('../components/area/area.vue'))
        Vue.component('Area2', () => import('../components/area/area2.vue'))
        Vue.component('dowmloadplace', () => import('../components/download/place.vue'))
        Vue.component('mapHeader', () => import('../components/map_header'))
    }
}
export default components